<template async>
  <nav>
    <Banner  @show-component="showComponent" />
  </nav>
  <Servicos/>
  <Whatsapp @show-component="showComponent"/>
  <Footer @show-component="showComponent"/>
  <component :parametroRecebido="parametroRecebido" class="popup-overlay" @click="showPopup = false" :is="currentComponent" v-if="isComponentVisible"  @show-component="showComponent" @remove-component="removeComponent" />
  <ModalPopup ref="modalPopup"/>
 </template>
<script async>

export default {
  name: 'app-main',
  data () {
    return {
      showPopup: false,
      isComponentVisible: false,
      currentComponent: null,
      modalPopup: null, // Armazena o componente carregado dinamicamente
      isModalVisible: false // Controla se o popup está visível
    }
  },
  components: {
    Footer: require('@/components/Footer.vue').default,
    Banner: require('@/components/Banner.vue').default,
    Servicos: require('@/components/Servicos.vue').default,
    Whatsapp: require('@/components/Whatsapp.vue').default
    // ModalPopup: require('@/components/ModalPopup.vue').default
  },
  mounted () {
    // Adiciona o evento beforeunload ao componente
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeUnmount () {
    // Remove o evento antes do componente ser destruído
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  updated () {
    window.speechSynthesis.cancel()
  },
  methods: {
    async showComponent (x) {
      this.parametroRecebido = x
      this.currentComponent = module.default
      this.isComponentVisible = true
    },
    removeComponent () {
      this.currentComponent = null
      this.isComponentVisible = false
      window.speechSynthesis.cancel()
    },
    async handleBeforeUnload (event) {
      event.preventDefault()
      if (!this.modalPopup) {
        const { default: ModalPopup } = await import('@/components/ModalPopup.vue')
        this.modalPopup = ModalPopup
        this.isModalVisible = true
      }
      event.returnValue = 'Tem certeza que deseja sair ou recarregar a página?'
    }
  }
}
</script>
<style async lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Teko:wght@300..700&display=swap');
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%!important;
  height: 100%!important;
  background: #000000e6;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  pointer-events: none;
  animation: fadeIn 0.5s forwards;
}

.popup-overlay .popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: center;
  animation: slideUp 0.5s ease-in-out;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    pointer-events: auto;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.title {
    font-family: "Teko", Sans-serif;
    font-size: 70px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    letter-spacing: -2.9px
}
/* @import  url(../src/css/main.min.css) screen and (min-width: 1080px);
@import url(../src/css/main.min.css) screen and (min-width: 640px);
@import url(../src/css/main.min.css) screen and (min-width: 256px); */
@import './scss/main.scss';

/* @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@1,300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap'); */
</style>
